<!-- started reprots -->


<!-- <div class="container-fluid px-0 setup-page-main">
  <div class="container-fluid px-0 starter-accordion-dropdown-arrow">
      <div class="card" *ngFor="let process of responseData">
          <ngb-accordion #acc="ngbAccordion" [activeIds]="activeIds">
              <ngb-panel [id]="process.processName">
                  <ng-template ngbPanelTitle>

                      <div class="d-flex align-items-center justify-content-center ">
                        <div class="process-details">
                          <h5 class="fw-600 font-size-20 text-center font-14 mb-0">
                              {{ process.processName | translate | async }}
                          </h5>
                      </div>
                      <div class="process-complete">
                          <h5 class="fw-600 f-20 text-nowrap text-end font-14 mb-0">
                              {{ process.pending }}/{{ process.complete + process.pending }} <span class="view-more-re">{{ "Completed" | translate | async }}</span>
                          </h5>
                      </div>
                      </div>
                  </ng-template>
                  <ng-template ngbPanelContent>
                      <div class="rest-setup-list starter-accordion-dropdown-arrow">
                          <div class="rest-setup-list-item-new " *ngFor="let task of process.childProcess">
                              <div class="d-flex align-items-center justify-content-between">
                                  <div class="">
                                    <h6 class="f-16 fw-600 mb-1 align-self-center process-color process-tex">
                                     {{ task.processName | translate | async }}
                                    </h6>
                                    <div class="f-12 fw-500 process-color mb-0 description-tex">{{ getProcessDesc(task.processName) | translate | async }}</div>
                                  </div>
                                  <div class="">
                                      <div class="d-flex justify-content-between">
                                          <div class="me-sm-5 me-2 align-self-center">
                                              <span *ngIf="task.status === 0" class="f-14 fw-600 complete-btn">{{ "Completed" | translate | async }}</span>
                                              <span *ngIf="task.status === 1" class="f-14 fw-600 pending-btn">{{ "Pending" | translate | async }}</span>
                                          </div>
                                          <div class="text-end align-self-center">
                                              <div class="d-flex justify-content-end">
                                                  <div>
                                                    <button class="d-flex align-items-center gap-2 f-12 fw-500 viewmore-btn"
                                                      (click)="toggleExtraRows(task)">

                                                      <span class="view-more-re">
                                                        {{ (showExtraRows[task.processName] ? 'View Less' : 'View More') | translate | async }}
                                                      </span>
                                                      <svg xmlns="http://www.w3.org/2000/svg" class=" icon icon-tabler icon-tabler-arrow-right" width="15" height="15"
                                                        viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round"
                                                        stroke-linejoin="round">
                                                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                        <line x1="5" y1="12" x2="19" y2="12"></line>
                                                        <line x1="13" y1="18" x2="19" y2="12"></line>
                                                        <line x1="13" y1="6" x2="19" y2="12"></line>
                                                      </svg>
                                                    </button>
                                                  </div>
                                                  <div class="ps-2 align-self-center" (click)="deleteRow($event , task)">
                                                    <img src="assets\images\close-complete.svg" alt="">

                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                </div>
                                <div *ngIf="showExtraRows[task.processName]">
                                  <form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="task.identifier === 'restaurant_information'">

                                    <div class="rest-setup-list-item" style="padding: 10px;">
                                      <div class="row mb-3">
                                        <label for="paymentidprifix" class="col-sm-5 col-form-label restau-name-responsive">{{ "Payment ID Prefix*" | translate | async }}
                                        </label>
                                        <div class="col-sm-7 sm-mt-0 mt-2 px-0">
                                          <input accessControl module="General" access="3" type="text" class="form-control" id="paymentidprifix"
                                            maxlength="5" [placeholder]="'Payment ID' | translate | async" formControlName="paymentIdPrefix" [(ngModel)]="paymentIdPrefix" />
                                        </div>
                                      </div>
                                    </div>

                                    <div class="rest-setup-list-item" style="padding: 10px;">
                                      <div class="row mb-3">
                                        <label for="paymentidprifix" class="col-sm-5 col-form-label restau-name-responsive">{{ "Transaction ID Prefix*" | translate | async }}
                                        </label>
                                        <div class="col-sm-7 sm-mt-0 mt-2 px-0">
                                          <input accessControl module="General" access="3" type="text" class="form-control" id="transactionidprifix"
                                            maxlength="5" placeholder="Transaction Id" formControlName="transactionIdPrefix"
                                            [(ngModel)]="transactionIdPrefix" />



                                        </div>
                                      </div>
                                    </div>
                                    <div class="rest-setup-list-item" style="padding: 10px;">
                                      <div class="row mb-3">
                                        <label for="restaurentwebsite" class="col-sm-5 col-form-label restau-name-responsive">{{ "Restaurant" | translate | async }}
                                          {{ "Website*" | translate | async }}</label>
                                        <div class="col-sm-7 sm-mt-0 mt-2 px-0">
                                          <input accessControl module="General" access="3" type="text" class="form-control" id="website"
                                            [placeholder]="'Restaurant Website' | translate | async" name="website" id="website" [(ngModel)]="restaurantWebsite"
                                            formControlName="restaurantWebsite" />
                                        </div>
                                      </div>
                                    </div>
                                    <div class="rest-setup-list-item" style="padding: 10px;">
                                      <div class="row mb-3">
                                        <label for="email" class="col-sm-5 col-form-label restau-name-responsive">{{ "Restaurant Email" | translate | async }}*</label>
                                        <div class="col-sm-7 sm-mt-0 mt-2 px-0">
                                          <input accessControl module="General" access="3" type="email" class="form-control" id="inputEmail3"
                                            [placeholder]="'Restaurant Email' | translate | async" [(ngModel)]="merchantEmailAccount" formControlName="merchantEmailAccount" />
                                          <div
                                            *ngIf="(submitted || form.controls.merchantEmailAccount.touched) && form.controls.merchantEmailAccount.errors"
                                            class="text-danger">
                                            {{ "Invalid email address" | translate | async }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="rest-setup-list-item" style="padding: 10px;">
                                      <div class="row mb-3">
                                        <label for="phone" class="col-sm-5 col-form-label restau-name-responsive">{{ "Restaurant Phone*" | translate | async }}</label>
                                        <div class="col-sm-7 sm-mt-0 mt-2 px-0">

                                          <ngx-intl-tel-input [cssClass]="'form-control'" [preferredCountries]="preferredCountries"
                                            [enableAutoCountrySelect]="true" [enablePlaceholder]="false" [searchCountryFlag]="true"
                                            [selectFirstCountry]="true" [maxLength]="10" [phoneValidation]="true" [separateDialCode]="true"
                                            [inputId]="'inputPhone'" name="phone" formControlName="merchantMobile" [(ngModel)]="merchantMobile">
                                          </ngx-intl-tel-input>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="rest-setup-list-item" style="padding: 10px;">

                                          <div class="row">
                                            <label for="address" class="col-sm-5 col-form-label restau-name-responsive">Address*</label>
                                            <div class="col-sm-7 sm-mt-0 mt-2 px-0">
                                              <div class="mb-3">
                                                <input accessControl module="General" access="3" type="text" class="form-control"
                                                  [placeholder]="'Address Line 1' | translate | async" [(ngModel)]="merchantAddress1" formControlName="merchantAddress1"
                                                  id="autocomplete" autocorrect="off" autocapitalize="off" spellcheck="off"
                                                  class="form-control label-address address-input" #search />
                                                <div
                                                  *ngIf=" (submitted ||form.controls.merchantAddress1.touched )&& form.controls.merchantAddress1.errors"
                                                  class="text-danger">
                                                  {{ "Please Enter Address" | translate | async }}
                                                </div>
                                              </div>
                                              <div class="mb-3">
                                                <input accessControl module="General" access="3" type="text" class="form-control" id="inputAddress2"
                                                  formControlName="merchantAddress2" [placeholder]="'Address Line 2' | translate | async" [(ngModel)]="merchantAddress2" />

                                              </div>
                                              <div class="mb-3">
                                                <input accessControl module="General" access="3" type="text" class="form-control" id="inputCity"
                                                  placeholder="City" [(ngModel)]="merchantCity" formControlName="merchantCity" />



                                                <div *ngIf=" (submitted ||form.controls.merchantCity.touched )&& form.controls.merchantCity.errors"
                                                  class="text-danger">
                                                  {{ "Please Enter city" | translate | async }}
                                                </div>
                                              </div>
                                              <div class="row d-flex mb-3">
                                                <div class="col-6">
                                                  <input accessControl module="General" access="3" type="text" class="form-control" id="inputZip"
                                                    [placeholder]="'State' | translate | async" [(ngModel)]="merchantState" formControlName="merchantState" />
                                                  <div *ngIf="(submitted ||form.controls.merchantState.touched) && form.controls.merchantState.errors"
                                                    class="text-danger">
                                                    {{ "Please Enter State" | translate | async }}
                                                  </div>
                                                </div>
                                                <div class="col-6">
                                                  <input accessControl module="General" access="3" type="text" class="form-control" id="Postal Code"
                                                    [placeholder]="'Postal Code' | translate | async" [(ngModel)]="merchantZipCode"
                                                    formControlName="merchantZipCode" />

                                                  <div
                                                    *ngIf="(submitted || form.controls.merchantZipCode.touched) && form.controls.merchantZipCode.errors"
                                                    class="text-danger">
                                                    {{ "Please enter Zipcode" | translate | async }}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                    </div>
                                    <button type="submit" class="submit-button">{{ "Submit" | translate | async }}</button>
                                  </form>
                                  <form [formGroup]="serviceAreaForm" (ngSubmit)="onSubmitZone()" *ngIf="task.identifier === 'service_area_setup'" class="mt-3">

                                    <div class="fw-500 f-14 detail-da">
                                      <span>{{ "Enter the details for the floor layout in your restaurant." | translate | async }}</span>
                                    </div>
                                    <div class="modal-body border-0 pt-1">
                                      <div class="form-group">
                                        <label class="input-label">{{ "Floor Name*" | translate | async }}</label>
                                        <input class="form-control input-width" [placeholder]="'Enter Floor Name' | translate | async" [(ngModel)]="zoneName" formControlName="zoneName"
                                          maxlength="50" />
                                        <div
                                          *ngIf="(submittedFloor || serviceAreaForm.controls.zoneName.touched) && serviceAreaForm.controls.zoneName.errors?.required"
                                          class="text-danger">
                                          {{ "Floor Name is required." | translate | async }}
                                        </div>
                                      </div>
                                      <div class="form-group mt-3">
                                        <label class="input-label">{{ "Floor Number" | translate | async }}</label>
                                        <input class="form-control input-width" [placeholder]="'Enter Floor Number' | translate | async" [(ngModel)]="zoneNumber"
                                          formControlName="zoneNumber" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                                        <div
                                          *ngIf="(submittedFloor || serviceAreaForm.controls.zoneNumber.touched) && serviceAreaForm.controls.zoneNumber.errors?.required"
                                          class="text-danger">
                                          {{ "Floor Number is required." | translate | async }}
                                        </div>
                                      </div>
                                      <button accessControl module="ServiceArea" access="3" type="submit" [disabled]="serviceAreaForm.invalid"
                                            class="btn btn-dark eatos-submit-btn w-100 add-btn button-width mt-3">
                                            <span *ngIf="loader">{{ "Please wait..." | translate | async }}</span>
                                            <span *ngIf="!loader">{{ "Add" | translate | async }}</span>
                                          </button>
                                    </div>
                                  </form>
                                </div>
                          </div>
                      </div>
                  </ng-template>
              </ngb-panel>
          </ngb-accordion>
      </div>
  </div>
</div> -->

<!-- ended reports -->

<div class="container-fluid px-0 mb-4">
  <div class="container-fluid px-0">
     <!-- Warning Alert -->
     <!-- <div *ngIf="showAlert" class="alert alert-warning mb-4" role="alert">
      <i class="fas fa-exclamation-triangle me-2"></i>
         <span> {{alertMsg}} </span> 
        <span style="cursor:pointer; margin-left: 10px;" class="badge bg-dark" (click)="alertClose()">{{buttonText}}</span>
    </div> -->
    <div *ngIf="showAlert" class="alert alert-warning mb-4" role="alert">
      <i class="fas fa-exclamation-triangle me-2"></i>
      <span>{{ alertMsg }}</span>
      <span *ngFor="let button of buttonText" style="cursor:pointer; margin-left: 10px;" class="badge bg-dark" (click)="alertClose(button)">
        {{ button }}
      </span>
    </div>
    <div *canAccess="['DashboardReport', [1,2,3]]" >
      <app-live-card></app-live-card>
      <app-net-sale></app-net-sale>
      <app-dashboard-report></app-dashboard-report>
    </div>

    <div *canAccess="['DashboardReport', 0]" class="reports-no-discounts">
      <div class="empty-discounts-note">
        <i class="mdi mdi-lock" style="font-size: 50px;"></i>
        <div class="mt-3"></div>
        <div>{{ "Oops!! It appears that you do not have access to reports. Please get in touch with your manager." | translate | async }}</div>
      </div>
    </div>
<!-- <div class="d-flex gap-3">


    <div class="container " style="max-width: 100% !important;">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-4 mt-4" style="padding-left: 0 !important;">
          <div class="card br-0 dashboard-main row mx-0" style="margin-bottom: 20px">
            <div class="card-body report-RTL-overview p-0">
              <div class="row allchart-dashboard-RTL">
                <div class="container col">
                  <h6 class="fw-600 mb-4 font-size-20">{{ "eatOS recommends" | translate | async }}</h6>
                  <div class="image-container">
                    <img src="assets/images/feature-page-image/sales/Sales-Cash-Drawers.svg" alt="Marketing Recommendations">
                  </div>
                  <p class="fw-bold">The average eatOS Payroll Suite customer runs payroll in 15 minutes or less*.</p>
                  <p >Stop dreading payday. With the Payroll Suite, easily (and accurately!) post payroll from anywhere,
                    hire new employees quickly, support your team's needs, and retain your best talent.</p>
                  <button class="upgrade-btn" (click)="employeelist()">Learn how</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-4 mt-4" style="padding: 0 !important;">
          <div class="card br-0 dashboard-main row mx-0" style="margin-bottom: 20px">
            <div class="card-body report-RTL-overview p-0">
              <div class="row allchart-dashboard-RTL">
                <div class="container col">
                  <h6 class="fw-600 mb-4 font-size-20">{{ "Referral Program" | translate | async }}</h6>
                  <div class="image-container">
                    <img src="assets/images/feature-page-image/sales/Sales-Cash-Drawers.svg" alt="Marketing Recommendations">
                  </div>
                  <p class="fw-bold">eatOS Referral Rewards Program</p>
                  <p>
                    Join the eatOS Referral Rewards Program and earn exciting benefits by sharing the power of our intuitive restaurant management platform with your network.
                    Whether you're an existing customer or a partner.Sign up today and start earning with every referral!
                  </p>
                  <button class="upgrade-btn" (click)="referral()">Learn how</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-4 mt-4" style="padding-right: 0 !important;">
          <div class="card br-0 dashboard-main row mx-0" style="margin-bottom: 20px">
            <div class="card-body report-RTL-overview p-0">
              <div class="row allchart-dashboard-RTL">
                <div class="container col">
                  <h6 class="fw-600 mb-4 font-size-20">{{ "Employee Schedule" | translate | async }}</h6>
                  <div class="image-container">
                    <img src="assets/images/feature-page-image/sales/Sales-Cash-Drawers.svg" alt="Marketing Recommendations">
                  </div>
                  <p class="fw-bold">eatOS Employee Scheduling Made Easy</p>
                  <p >Empower your team with easy access to their work hours and instant updates, while reducing scheduling conflicts and labor costs. Simplify your staff management and boost productivity with eatOS today!</p>
                  <button class="upgrade-btn" (click)="employeeShift()">Learn how</button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div> -->

  <!-- <div class="card br-0 dashboard-main row mx-0" style="margin-bottom: 20px">
    <div class="card-body report-RTL-overview ">
      <div class="row allchart-dashboard-RTL">
        <div class="container col">
          <h6 class="fw-600 mb-4 font-size-20">{{ "eatOS recommends" | translate | async }}</h6>
          <div class="image-container">
            <img src="assets/images/feature-page-image/sales/Sales-Cash-Drawers.svg" alt="Marketing Recommendations">
          </div>
          <p class="fw-bold">The average eatOS Payroll Suite customer runs payroll in 15 minutes or less*.</p>
          <p >Stop dreading payday. With the Payroll Suite, easily (and accurately!) post payroll from anywhere,
            hire new employees quickly, support your team's needs, and retain your best talent.</p>
          <button class="upgrade-btn">Learn how</button>
        </div>
      </div>
    </div>
  </div> -->
</div>


  <div class="row dashboardRTL-eatOS-card mb-5" *ngIf="supportDiv == 1">
      <div class="col-xl-4 col-md-6">
        <div class="card">
          <div class="card-body card-image ">
            <div class="text-center box-height">
              <a href="https://eatos.com" target="blank" class="eatos-help-link">
                <img src="assets/images/eatOS-lg.png" class="mb-3">
                <h5 class="fw-600 font-size-22">
                 {{ "Go to" | translate | async }} eatOS.com
                </h5>
              </a>

            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-md-6">
        <div class="card">
          <div class="card-body">
            <div class="text-center box-height">
              <a href="https://support.eatos.com/en-us/" target="blank" class="eatos-help-link">
                <img src="assets/images/instructions.svg" class="mb-3">
                <h5 class="fw-600 font-size-22">
                  eatOS {{ "Support" | translate | async }}
                </h5>
                <div class="font-size-14">
                  {{ "Product Guides, Product Playbooks, Manuals" | translate | async }}
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-md-6">
        <div class="card">
          <div class="card-body">
            <div class="text-center box-height">
              <a href="https://support.eatos.com/en-us/category/frequently-asked-questions-1t6dv17/" target="blank"
                class="eatos-help-link">
                <img src="assets/images/faq.svg" class="mb-3">
                <h5 class="fw-600 font-size-22">
                  {{ "Frequently Asked Questions" | translate | async }}
                </h5>
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="Accordion-main-button">
        <button (click)="toggleAccordionmain()" class="Accordion-button">
          <span class="allLinks">
            Show me all links
            <i class="fa-solid" [ngClass]="{'fa-caret-up': isOpen, 'fa-caret-down': !isOpen}"></i>
          </span>
        </button>
        <div class="accordion-content mt-3" *ngIf="isOpen">
          <div class="scrollable-content row">
            <div class="col-lg-4">
              <ul class="action-list">
                <li>
                  <a routerLink="/menumanagement/menus/menu-home" class="action-link">
                    <img src="assets/images/newsidemenu-image/default/bx-file-1.svg" >
                    <span class="action-text accordion-border-bottom">{{ "Menu Management" | translate | async }}</span>
                  </a>
                </li>

                <ul class="m-0 pl-63">
                  <li>
                    <a class="underline" routerLink="/menumanagement/menu-builder">Menu Builder</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/menumanagement/menus">Menus</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/menumanagement/products">Products</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/menumanagement/modifiers">Modifiers</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/menumanagement/Groups-Modifiers-Add-Ons">Groups</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/menumanagement/addons">Add On</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/menumanagement/ingredients">Default Modifiers</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/menumanagement/categories">Categories</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/menumanagement/courses">Courses</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/menumanagement/service-charge">Service Charges</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/menumanagement/discounts">Discounts</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/menumanagement/taxes">Taxes</a>
                  </li>

                </ul>

                <li>
                  <a routerLink="/marketing" class="action-link">
                    <img src="assets/images/newsidemenu-image/default/guest.svg" alt="Menu Management">
                    <span class="action-text accordion-border-bottom">{{ "Marketing" | translate | async }}</span>
                  </a>
                </li>

                <ul class="m-0 pl-63">
                  <li>
                    <a class="underline" routerLink="/marketing/newHomepage">Overview</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/marketing/createcampaign">Create-Campaign</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/marketing/smart-group">Smart Group</a>
                  </li>
                </ul>

              </ul>
            </div>
            <div class="col-lg-4">

              <ul class="action-list">
                <li>
                  <a routerLink="/reports/sales/gross-transaction/report-home" class="action-link">
                    <img src="assets/images/newsidemenu-image/default/Analytics.svg" alt="Daily Services Transactions">
                    <span class="action-text accordion-border-bottom">{{ "Analytics & Reports" | translate | async }}</span>
                  </a>
                </li>
                <ul class="m-0 pl-63">
                  <li>
                    <a class="underline" routerLink="/reports/sales/gross-shift">Daily Services Transactions</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/reports/labor/tip-report" >Tip</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/reports/labor/payroll">Payroll</a>
                  </li>
                  <li>
                    <a class="underline"  routerLink="/reports/labor/cashout">Cashout</a>
                  </li>

                </ul>
                <li>
                  <a routerLink="/employees/employeelist/employee-home" class="action-link">
                    <img src="assets/images/newsidemenu-image/default/workforce.svg" alt="Workforce">
                    <span class="action-text accordion-border-bottom">{{ "Workforce" | translate | async }}</span>
                  </a>
                </li>
                <ul class="m-0 pl-63">
                  <li>
                    <a class="underline" routerLink="/employees/employeelist">Employees</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/employees/timesheet">Timesheet</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/employees/jobtypes">Job Types</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/employees/roles">Roles</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/employees/department">Department</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/employees/shift">Shift</a>
                  </li>
                </ul>
                <li>
                  <a routerLink="/onlinestore/online-store-home" class="action-link">
                    <img src="assets/images/newsidemenu-image/default/online-order.svg" alt="Workforce">
                    <span class="action-text accordion-border-bottom">{{ "Online Ordering" | translate | async }}</span>
                  </a>
                </li>
                <ul class="m-0 pl-63">
                  <li>
                    <a class="underline" routerLink="/onlinestore">General</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/onlinestore/store-front-settings">Storefront Settings</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/onlinestore/delivery">Delivery</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/onlinestore/payment">Payment</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/onlinestore/schedule">Schedule</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/onlinestore/support">Support</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/onlinestore/promo-code">Promo Code</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/onlinestore/qr-code">QR Order at Table</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/onlinestore/driver">Driver</a>
                  </li>
                </ul>

              </ul>
            </div>
            <div class="col-lg-4">
              <ul class="action-list">
                <li>
                  <a routerLink="/sales/transactions/sales-home" class="action-link">
                    <img src="assets/images/newsidemenu-image/default/sales.svg" alt="Sales Transaction">
                    <span class="action-text accordion-border-bottom">{{ "Sales" | translate | async }}</span>
                  </a>
                </li>

                <ul class="m-0 pl-63">
                  <li>
                    <a class="underline" routerLink="/sales/transactions">Transactions</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/sales/orders">Orders</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/sales/cashdrawers">Cash Drawers</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/sales/deposits">Deposits</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/sales/service-charges">Service charges</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/sales/discounts">Discounts</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/sales/promo-code">Promo Code</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/sales/feedback">Feedback</a>
                  </li>
                </ul>
                <li>
                  <a routerLink="/restaurant/general/restaurant-home" class="action-link">
                    <img src="assets/images/newsidemenu-image/default/Restaurant.svg" alt="Sales Transaction">
                    <span class="action-text accordion-border-bottom">{{ "Restaurant" | translate | async }}</span>
                  </a>
                </li>
                <ul class="m-0 pl-63">
                  <li>
                    <a class="underline" routerLink="/restaurant/general">General</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/restaurant/schedule">Schedule</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/restaurant/revenuecenter">Revenue-Center</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/restaurant/service-areas">Service-Areas</a>
                  </li>
                  <li>
                    <a class="underline" routerLink="/restaurant/receiptbuilder">Receipt-Builder</a>
                  </li>
                </ul>
              </ul>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>

